export default __webpack_public_path__ + "static/media/jira_icon.88c20273.svg";